import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    {/* <g transform="translate(-8.000000, -2.000000)"> */}
    <g transform="translate(22.000000, 27.000000)">
      <path
        d="M0.45 33L10.6 0.399999H19.4L29.55 33H21.75L17.55 16.5C17.15 14.8667 16.7167 13.1333 16.25 11.3C15.7833 9.46667 15.35 7.7 14.95 6H14.75C14.35 7.7 13.9333 9.46667 13.5 11.3C13.0667 13.1333 12.6333 14.8667 12.2 16.5L7.95 33H0.45ZM7.15 25.25V19.5H22.75V25.25H7.15Z"
        // d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2 C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3 L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65 C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85 44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8 L33.591667,34.8 L33.591667,43.2 Z M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5 45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5 40.191667,47.5 L33.591667,47.5 Z"
        fill="currentColor"
      />
    </g>
    <polygon
      id="Shape"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="39 0 0 22 0 67 39 90 78 68 78 23"
    />
    {/* </g> */}
  </svg>
);

export default IconLogo;
